const DocExtension = ['png', 'jpg', 'jpeg', 'pdf', 'dwg', 'dwf', 'rar', 'zip'];
const NCsCsExtension = ['png', 'jpg', 'jpeg', 'pdf', 'mp4'];
const LogoOrgExtension = ['png', 'jpg', 'jpeg'];
const DownloadTypesExtension = ['zip', 'rar', 'dwg', 'dwf'];

export { DocExtension, NCsCsExtension, LogoOrgExtension, DownloadTypesExtension };